module.exports = __webpack_public_path__ + "static/media/sim-swap.8c20c2a4.svg";